export default __webpack_public_path__ + "static/146-7af647c3382ef15873fb6985cc6847a5.gif";